import { render, staticRenderFns } from "./CommunityForum.vue?vue&type=template&id=6a24b0e9&"
import script from "./CommunityForum.vue?vue&type=script&lang=ts&"
export * from "./CommunityForum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports